var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIPharmacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.293 31.693h-2.233l-2.352 4.26-3.090-5.653c1.548-1.003 2.378-2.767 2.378-5.029 0-3.441-1.695-5.865-5.552-5.865h-6.383v20.139h3.217v-8.321h2.821c0.236 0 0.437-0.036 0.66-0.054l4.283 7.8-3.552 6.433h2.25l2.421-4.395 2.415 4.395h3.299l-4.051-7.411 3.469-6.298zM29.563 28.797h-2.285v-6.967h2.064c2.566 0 3.438 1.327 3.438 3.497 0 2.539-1.494 3.47-3.218 3.47z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.43 61.86c0 1.178 0.987 2.14 2.204 2.14h24.166c1.219 0 2.199-0.962 2.199-2.14v-48.72h-28.569v48.72zM21.264 16.313h22.922v31.545h-22.922v-31.545z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.030 11.065h31.363c0.638 0 1.149-0.5 1.149-1.122v-8.129c0-0.62-0.511-1.118-1.149-1.118h-31.363c-0.633 0-1.151 0.498-1.151 1.118v8.129c0 0.622 0.519 1.122 1.151 1.122zM45.446 2.156h1.55v7.422h-1.55v-7.422zM41.985 2.156h1.544v7.422h-1.544v-7.422zM38.515 2.156h1.552v7.422h-1.552v-7.422z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPharmacy);
export default __webpack_public_path__ + "static/media/i-pharmacy.0bcb56f3.svg";
export { ForwardRef as ReactComponent };